import CalendarioImpl from "components/calendario/CalendarioImpl";
import AprobarVacaciones from "components/validarVacaciones/AprobarVacaciones";
import React from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import ViewMotivosAusencias from "./ViewMotivosAusencias";
import ComputoAusenciasAnual from "../../components/motivoAusencias/ComputoAusenciasAnual";
import {useParams} from "react-router-dom";

const ViewAporbarVacaciones = () => {
  const {empleadoId} = useParams();
  return (
    <>
      <Row>
        <Col lg={6}>
          <Card>
            <CardHeader>Solicitudes pendientes de validar</CardHeader>
           
              <AprobarVacaciones />
           
          </Card>
        </Col>
        <Col lg={6}>
          <CalendarioImpl></CalendarioImpl>
          <br/>
          <Card>
            <CardHeader>Recuento de ausencias anuales solicitadas año: {new Date().getFullYear()}</CardHeader>
            <ComputoAusenciasAnual empleadoId={empleadoId} year={new Date().getFullYear()}></ComputoAusenciasAnual>
          </Card>

        </Col>
      </Row>
    </>
  );
};

export default ViewAporbarVacaciones;
